export default "skymp5-front/5c2874217cce8f12078a4c478c7760a8.svg";